import(/* webpackPrefetch: true */ "babel-polyfill");
import Vue from "vue";
import App from "./App";
import router from "./router";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import store from "./store";
import moment from "moment";
import highcharts from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import "vuetify/dist/vuetify.js";
import VueWoker from "vue-worker";
import "./registerServiceWorker";
import VueLodash from "vue-lodash";
//import VueExcelXlsx from "vue-excel-xlsx";
import XLSX from 'xlsx/xlsx';
const options = { name: "lodash" };

Vue.prototype.moment = moment;
Vue.config.productionTip = true;
Vue.use(moment);
exportingInit(Highcharts);
Vue.use(highcharts);
Vue.use(VueWoker, "$WebWorker");
Vue.use(VueLodash, options);
//Vue.use(VueExcelXlsx);

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>",
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
